




import { defineComponent } from '@vue/composition-api';
import RichText from '@/components/storyblok/RichText.vue';

export default defineComponent({
  name: 'TrackInfoText',
  props: { blok: { type: Object } },
  components: { RichText }
});
